var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { unmountComponentAtNode, unstable_renderSubtreeIntoContainer as renderSubtreeIntoContainer } from 'react-dom';
import ExecutionEnvironment from 'fbjs/lib/ExecutionEnvironment';
import get from 'lodash/get';
import { browserHistory } from 'react-router';
export default function (_a) {
    var node = _a.node, nodeClassName = _a.nodeClassName;
    var Portal = /** @class */ (function (_super) {
        __extends(Portal, _super);
        function Portal(props) {
            var _this = _super.call(this, props) || this;
            _this.touchStartY = 0;
            _this.refreshThreshold = 10; // Pixels to pull down to trigger refresh
            _this.historyUnlisten = null;
            _this.handleTouchStart = function (e) {
                if (e.touches.length === 1) {
                    if (window.scrollY <= 10) {
                        _this.touchStartY = e.touches[0].clientY;
                    }
                }
            };
            _this.handleTouchMove = function (e) {
                if (e.touches.length === 1 && _this.touchStartY > 0) {
                    var touchY = e.touches[0].clientY;
                    var pullDistance = touchY - _this.touchStartY;
                    if (pullDistance > _this.refreshThreshold && window.scrollY <= 0) {
                        _this.cleanupPortal();
                        _this.touchStartY = 0;
                    }
                }
            };
            _this.handleTouchEnd = function () {
                _this.touchStartY = 0;
            };
            _this.handleVisibilityChange = function () {
                if (document.visibilityState === 'hidden') {
                    _this.cleanupPortal();
                }
            };
            _this.cleanupPortal = function () {
                if (node) {
                    unmountComponentAtNode(node);
                    _this.hide();
                }
            };
            _this.createPortal = _this.createPortal.bind(_this);
            _this.renderPortal = _this.renderPortal.bind(_this);
            _this.show = _this.show.bind(_this);
            _this.hide = _this.hide.bind(_this);
            _this.renderChildren = _this.renderChildren.bind(_this);
            return _this;
        }
        Portal.prototype.componentDidMount = function () {
            if (!ExecutionEnvironment.canUseDOM)
                return;
            this.renderPortal(this.props);
            // Listen for URL/history changes that might happen during native navigation
            window.addEventListener('popstate', this.cleanupPortal);
            // Listen for hash changes in URL (anchor navigation)
            window.addEventListener('hashchange', this.cleanupPortal);
            // Listen for visibility changes (tab switching, app backgrounding)
            document.addEventListener('visibilitychange', this.handleVisibilityChange);
            // Touch events to detect pull-to-refresh
            document.addEventListener('touchstart', this.handleTouchStart, { passive: true });
            document.addEventListener('touchmove', this.handleTouchMove, { passive: true });
            document.addEventListener('touchend', this.handleTouchEnd, { passive: true });
            // Listen for route changes through browserHistory
            if (browserHistory && typeof browserHistory.listen === 'function') {
                this.historyUnlisten = browserHistory.listen(this.cleanupPortal);
            }
        };
        Portal.prototype.componentWillUnmount = function () {
            if (node) {
                unmountComponentAtNode(node);
                if (node.parentNode) {
                    node.parentNode.removeChild(node);
                }
                node = null;
            }
            // Clean up event listeners
            window.removeEventListener('popstate', this.cleanupPortal);
            window.removeEventListener('hashchange', this.cleanupPortal);
            document.removeEventListener('visibilitychange', this.handleVisibilityChange);
            document.removeEventListener('touchstart', this.handleTouchStart);
            document.removeEventListener('touchmove', this.handleTouchMove);
            document.removeEventListener('touchend', this.handleTouchEnd);
            if (this.historyUnlisten) {
                this.historyUnlisten();
                this.historyUnlisten = null;
            }
        };
        Portal.prototype.show = function () {
            var showComponentFn = get(this, 'props.show');
            if (typeof showComponentFn === 'function') {
                showComponentFn();
            }
        };
        Portal.prototype.hide = function () {
            var hideComponentFn = get(this, 'props.hide');
            if (typeof hideComponentFn === 'function') {
                hideComponentFn();
            }
        };
        Portal.prototype.createPortal = function () {
            node = document.createElement('div');
            node.className = nodeClassName;
            document.body.appendChild(node);
        };
        Portal.prototype.renderPortal = function (props) {
            !node && this.createPortal();
            try {
                renderSubtreeIntoContainer(this, this.renderChildren(props), node);
            }
            catch (e) {
                console.error('Error rendering portal:', e);
            }
        };
        // Portal.renderChildren called in parent. Override this function if inheriting from this component.
        Portal.prototype.renderChildren = function (props, active) {
            if (typeof props === 'undefined' && typeof active === 'undefined') {
                return this.props.children;
            }
            return <span />;
        };
        Portal.prototype.render = function () {
            return null;
        };
        return Portal;
    }(React.Component));
    return Portal;
}
